import React from 'react';
import isEmpty from 'lodash/isEmpty';
import cx from "classnames";
import { Desktop } from '../Responsive';


const StepOption = ({ option, selected, active, ...props }) =>(<>
        <div className="flex cursor-pointer items-center">
            <i className="option-icon fa fa-flag mr-2" />
            <span
                className={cx("truncate", {
                    "font-semibold": selected,
                })}
            >
                {option.step.title}
            </span>
        </div>
    </>)
;

const LocalityOption = ({ option, selected, active, ...props }) =>
    (<>
        <div className="flex cursor-pointer items-center">
            <i className="option-icon fa fa-flag mr-2" />
            <span
                className={cx("truncate", {
                    "font-semibold": selected,
                })}
            >
                {option.step.title}
            </span>
            <span
                className={cx(
                    "ml-2 truncate", {
                        "text-gray-200" : active,
                        "text-gray-500": ! active
                    }
                )}
            >
              - {option.locality.title}
          </span>
        </div>
    </>)
;

const StopOption = ({ option, isBus, isLodging, selected, active, ...props }) =>
    (<>
        <div className="flex cursor-pointer items-center">
            {(isBus && isLodging) &&
                <span>
                <i className="value-icon fa fa-bus mr-2" />
                    &nbsp;
                    <i className="value-icon fa fa-bed mr-2" />
            </span>
            }
            {(isBus && !isLodging) && <i className="value-icon fa fa-bus mr-2" />}
            {(isLodging && !isBus) && <i className="value-icon fa fa-bed mr-2" />}
            {(!isLodging && !isBus) && <i className="value-icon fa fa-bed mr-2" />}
            <span
                className={cx("truncate", {
                    "font-semibold": selected,
                })}
            >
                {option.stop.title}
            </span>
            <span
                className={cx(
                    "ml-2 truncate", {
                        "text-gray-200" : active,
                        "text-gray-500": ! active
                    }
                )}
            >
                <Desktop>
                    {!isEmpty(option.step) && <span className="option-title-sep"> - </span>}
                    {!isEmpty(option.step) && option.step.title}
                    {!isEmpty(option.locality) && <span className="option-title-sep"> - </span>}
                    {!isEmpty(option.locality) && option.locality.title}
                </Desktop>
          </span>
        </div>
    </>)
;

export {
    StepOption,
    LocalityOption,
    StopOption
};
